/**
 * Step Context Utilities
 * Common utilities for handling step context in button handlers
 */

import type { Dispatch } from '@reduxjs/toolkit';

import { setActiveStep } from '../data-store/copilotSlice';

interface ButtonContext {
  label?: string;
  stepName?: string;
}

/**
 * Utility to handle step context before executing button action
 * Ensures messages appear under correct step
 */
const withStepContext = (
  context: ButtonContext | undefined,
  dispatch: Dispatch,
  getState: () => unknown,
  action: () => void | Promise<void>
) => {
  const originalStep = context?.stepName;
  const state = getState() as {
    copilot?: { navigation?: { activeStep?: string } };
  };
  const currentStep = state.copilot?.navigation?.activeStep;

  if (originalStep && originalStep !== currentStep) {
    dispatch(setActiveStep(originalStep));
  }

  return action();
};

export default withStepContext;
